<div class="fv-wrapper" [class.fv-disabled]="disabled" [class.fv-checked]="checked">
  <div class="form-check form-switch modern-switch">
    <input
      class="form-check-input"
      type="checkbox"
      role="switch"
      [id]="campoKey + '-' + (recadastroId || cadastroId)"
      [checked]="checked"
      [disabled]="disabled"
      (change)="onToggle($event)"
      [attr.aria-label]="label + ' (' + campoKey + ')'"
    />
    <label class="form-check-label small" [for]="campoKey + '-' + (recadastroId || cadastroId)">
      <span class="state-text" [class.state-valid]="checked" [class.state-invalid]="!checked">
        {{ checked ? 'Validado' : 'Invalido' }}
      </span>
    </label>
  </div>

  <div class="mini-state">
    <div *ngIf="saving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
    <i *ngIf="error" class="bi bi-exclamation-triangle-fill text-danger" [title]="error"></i>
  </div>

  <div *ngIf="observacaoEnabled && showObservacao" class="obs">
    <input
      [disabled]="disabled"
      class="form-control form-control-sm"
      type="text"
      [placeholder]="observacaoPlaceholder"
      [(ngModel)]="observacao"
      (blur)="onObsBlur()"
    />
  </div>
</div>